/**
 * Per-module state for a funeral home — the frontend mirror of
 * resolveStoreModuleStates() in api/src/modules/stores/store.service.js.
 *
 * This is the ONLY place in the frontend that should read `store.modules`.
 * Reading the raw shape ad hoc is how the two sides drift: the panel would show
 * a page the API then 403s on, or hide one it would have allowed.
 */

export const MODULES = ['edisplayroom', 'infinity_touch'];

export const MODULE_LABELS = {
    edisplayroom: 'e-Displayroom',
    infinity_touch: 'Infinity Touch'
};

/**
 * Capsule colours per platform. Deliberately the same palette the Channel column
 * on /admin/orders uses (AdminOrders.jsx CHANNEL_BADGE) so a platform reads the
 * same colour wherever it appears. On/off state is shown by dimming, not by hue.
 */
export const MODULE_BADGE = {
    edisplayroom: 'bg-slate-100 text-slate-700',
    infinity_touch: 'bg-blue-100 text-blue-700'
};

/**
 * @returns {{ [module: string]: {
 *   enabled: boolean,       // on right now
 *   everEnabled: boolean,   // on now, or was at some point
 *   visible: boolean,       // show this module's menus at all
 *   readOnly: boolean       // show them, but no writes
 * } }}
 */
export function resolveModuleStates(store) {
    const modules = (store && store.modules) || {};
    const states = {};
    for (const name of MODULES) {
        const state = modules[name] || {};
        const enabled = state.enabled === true;
        const everEnabled = enabled || state.ever_enabled === true;
        states[name] = {
            enabled,
            everEnabled,
            // A funeral home that had a platform switched off keeps its menus so
            // it can still reach its history; one that never had it sees nothing.
            visible: enabled || everEnabled,
            readOnly: !enabled && everEnabled
        };
    }
    return states;
}

/** Copy for the banner shown at the top of a read-only module's pages. */
export function moduleReadOnlyMessage(moduleName) {
    return `The ${MODULE_LABELS[moduleName] || moduleName} module is turned off for your account. `
        + 'You can still view your existing records, but no changes can be made. '
        + 'Contact your administrator to turn it back on.';
}
